import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { JwtDecoded } from '../../auth/models/jwt-decoded.model';

@Injectable({
	providedIn: 'root',
})
export class AppState {
	/**
	 * Currently logged in user
	 */
	private _loggedUser: BehaviorSubject<null | JwtDecoded>;

	constructor() {
		this._loggedUser = new BehaviorSubject<null | JwtDecoded>(null);
	}

	loggedUser$(): Observable<null | JwtDecoded> {
		return this._loggedUser.asObservable();
	}

	loggedUser(): JwtDecoded {
		return this._loggedUser.getValue() || new JwtDecoded();
	}

	setLoggedUser(user: JwtDecoded): void {
		this._loggedUser.next(user);
	}
}
